import { netsparkAxios } from 'core/services/HTTPService';
import { openApiUrl } from 'core/api/openapi.api/constants';
import { IOpenapiSchemaRequest } from 'core/models/openapi.models';

export const getOpenapiSchema = async () => netsparkAxios.get<IOpenapiSchemaRequest>(openApiUrl);
